export default __webpack_public_path__ + "static/italmodCEO-9803ac58-b97be0b9f6cebb3cb4f6e9bebe25a47c.webp";